import React, { ReactElement, useMemo } from 'react';
import { Tabs } from '@features/Tabs';
import { Balance, Transactions, General } from '../';
import { Rpt, Stmt } from '@shared/api';
import './ISOReportTabs.scss';

interface ITabsContent {
    [key: string]: ReactElement;
}

interface IISOReportTabsProps {
    data: Rpt | Stmt;
}

export const ISOReportTabs: React.FC<IISOReportTabsProps> = ({ data }) => {
    console.log(data);
    const tabsContent: ITabsContent = useMemo(
        () => ({
            General: <General data={data} />,
            Balance: <Balance balance={data.bal} />,
            Credits: <Transactions transactions={data.ntry?.filter((ntryItem) => ntryItem.cdtDbtInd === 'CRDT')} />,
            Debits: <Transactions transactions={data.ntry?.filter((ntryItem) => ntryItem.cdtDbtInd === 'DBIT')} />,
        }),
        [],
    );
    return (
        <Tabs
            tabsContent={tabsContent}
            initialTab={'General'}
        />
    );
};
